import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RestApiService } from '@core/services/rest-api.service';
import {
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  FormOf,
} from '@devinco/ui/legacy';
import { NewPoiDialogData, POIDto } from '@pages/poi-page/interfaces';
import { NewPoiDialogService } from './new-poi-dialog.service';
import { MapModule } from '@features/map/map.module';
import { take } from 'rxjs';
import { Entity } from '@shared/constants/entity';
import { MapMarker } from '@features/map/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';
import { MapId } from '@features/map/constants/map-id.enum';
import { DvSplitterEventsService } from '@devinco/ui/dds/splitter';

@Component({
  imports: [
    CommonModule,
    MapModule,
    DvDynamicFormModule,
    PipesModule,
    DvDialogContentComponent,
    TranslateModule,
    DvButtonComponent,
  ],
  selector: 'app-new-poi-dialog',
  templateUrl: './new-poi-dialog.component.html',
  styleUrls: ['./new-poi-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [NewPoiDialogService],
})
export class NewPoiDialogComponent
  extends DvDialogContent<NewPoiDialogData, NewPoiDialogComponent>
  implements OnInit
{
  readonly splitterEvents = inject(DvSplitterEventsService);
  private dialogService = inject(NewPoiDialogService);
  private api = inject(RestApiService);

  formGroup: FormGroup<FormOf<Partial<POIDto>>>;
  elements: DvDynamicFormElement[];
  marker: MapMarker;

  readonly mapId = MapId.POIMap;

  ngOnInit(): void {
    this.elements = this.dialogService.elements;
    this.formGroup = DvFormUtils.createFormGroup(this.elements);
    this.formGroup.patchValue(this.data);
    this.createMapMarker();
  }

  performSave(): void {
    this.api
      .upsert(Entity.POI, '0', this.formGroup.getRawValue())
      .pipe(take(1))
      .subscribe(() => this.dialogRef.onConfirm());
  }

  cancel(): void {
    this.dialogRef.onCancel();
  }
  private createMapMarker(): void {
    this.marker = {
      lat: this.data.GPSLat!,
      lng: this.data.GPSLon!,
      options: {
        isToolTipPermanent: true,
        tooltipValue: this.data.tooltip,
      },
    };
  }
}
